<template>
  <div class="lightbox">
    <transition name="fade">
      <div class="backdrop" v-if="show" @click="backdropClick">
        <div :class="{'for-image': image !== ''}">
          <img v-if="image !== ''" :src="image" />
          <!-- <div class="image" v-if="image !== ''">

          </div> -->
          <div v-else>
            <font-awesome-icon :icon="icons.times" @click="close"/>
            <div :key="item.Title">
              <div v-if="item.Image && item.Image !== ''" class="has-text-centered">
                <img :src="item.Image" />
              </div>
              <h1 v-if="item.Title && item.Title !== ''" class="title is-5" v-html="item.Title"></h1>
              <p v-if="item.Text && item.Text !== ''" v-html="item.Text"></p>
              <a v-if="item.Link && item.Link !== ''" :href="item.Link" target="_blank">
                <font-awesome-icon :icon="icons.externalLink" />
                {{ $t("General.Website") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { faTimes as farTimes, faExternalLink } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'lightbox',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    closeOnAnywhere: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
    image: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      icons: {
        times: farTimes,
        externalLink: faExternalLink
      }
    }
  },
  components: { },
  computed: {
  },
  methods: {
    backdropClick () {
      if (this.closeOnAnywhere) {
        this.close()
      }
    },
    close () {
      this.$emit('onclose')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1111;
  background-color: rgba(0, 0, 0, 0.3);

  > div {
    background-color: $white;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    height: auto;
    width: auto;
    min-height: 40px;
    max-height: 90%;
    min-width: 240px;
    max-width: 90%;
    padding: 30px 40px 30px 40px;
    box-shadow: 0px 0px 40px -10px rgba(0, 0, 0, 0.5);
    color: $text;
    text-align: left;
    overflow-y: auto;
    overflow-x: hidden;

    @media screen and (max-width: $bp-tablet - 1px){
      max-width: calc(100% - 20px);
      width: 90%;
      padding: 10px 15px 10px 15px;
    }

    &.for-image{
      padding: 0px;
    }

    [data-icon="times"] {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 14px;
      height: 14px;
      cursor: pointer;
      opacity: 0.6;

      &:hover {
        opacity: 1;
      }
    }
    img{
      max-height: 80px;
      max-width: 100%;
    }
    &.for-image{
      img{
        display: block;
        min-height: 50px;
        width: 100%;
        max-width: 100%;
        max-height: 100%;
        height: 100%;
      }
      div{
        img{
          min-height: 50px;
          width: auto;
          max-width: 100%;
          max-height: 100%;
          height: auto;
        }
      }
    }
    h1 {
      margin: 0 0 10px 0;
    }
    a{
      display: block;
      margin-top: 10px;
    }
  }
}
</style>
